import {signOut} from 'firebase/auth'
import {auth} from "../../fire";

export const salirAunth = () => {

    signOut(auth).then((dox) => {

    })
}